import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from '../components/enums'

export const reEvaluationRequest = async (data: object) => {
  return axios.put(endpoints.reEvaluationRequest, data)
}

export const useReEvaluationRequest = () => {
  const queryClient = useQueryClient()
  return useMutation(reEvaluationRequest, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.incidents, ApiKey.list])
    },
  })
}
